import { RHFAutocomplete } from '@/components/forms/hook-form';
import { useTranslation } from 'react-i18next';

export interface OrganizationSelectOption {
  _id: string;
  name: string;
  label: string;
}

interface OrganizationsSelectProps {
  name?: string;
  label?: string;
  placeholder?: string;
  options: OrganizationSelectOption[];
  isLoading?: boolean;
  disabled?: boolean;
  onChange?: (event: any, newValue: any) => void;
}

export const OrganizationsSelect = ({
  name = 'organization',
  label,
  placeholder,
  options,
  isLoading,
  disabled,
  onChange,
}: OrganizationsSelectProps) => {
  const { t } = useTranslation();

  return (
    <RHFAutocomplete
      disabled={disabled || isLoading}
      name={name}
      label={label || `${t('Company')} *`}
      placeholder={placeholder || t('Search and select a company...')}
      options={options}
      onChange={onChange}
      isOptionEqualToValue={(option, value: OrganizationSelectOption | null) =>
        value && option ? option._id === value._id : false
      }
    />
  );
};
